import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=76f25fad&scoped=true&"
var script = {}
import style0 from "./wrapper.vue?vue&type=style&index=0&id=76f25fad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f25fad",
  null
  
)

export default component.exports